
<div class="tab-pane show active" id="pills-kycdetail"
role="tabpanel" aria-labelledby="pills-kycdetail-tab">
<h1 class="page-sub-title cv-text-dark mb-4 mt-4 d-flex align-items-center"><a (click)="mobileBack()"
    class=""><img [src]='environment1 + "assets/images/c-arrow-left.svg"' class="img-fluid me-2"
      loading="lazy" /></a>KYC Details</h1>
<div class="row p-3">
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 co-xl-6 mb-4" *ngIf="userData?.account_type === 'Individual'">
    <div class=" mb-3">
      <label class="form-label" style="color: #27292F;font-weight: 700; font-size: 16px;">Address
        proof</label>
      <select class="form-select form-select-lg h-48" [(ngModel)]="selectedAddressProof">
        <option disabled selected value="null">Select proof type</option>
        <option *ngFor="let item of addressProofList" value="{{item.value}}">{{ item.name }}</option>
      </select>
    </div>

    <div class="upload-document">
      <label class="form-label mend">Document No.</label>
      <input type="text" class="form-control h-48" placeholder="EX:678967564534" minlength="12"
        maxlength="12" [(ngModel)]="selectedAddDocNo" (keypress)="onlyNumberKey($event)" #adhaar [ngClass]="isAddKYCDone && isIdKYCDone ? 'disabled' : ''"
        (input)="masking(adhaar.value)" />

    </div>

  </div>

  <div class="col-12 col-sm-12 col-md-6 col-lg-6 co-xl-6 mb-4">
    <div class=" mb-3">
      <label class="form-label" style="color: #27292F;font-weight: 700; font-size: 16px;">ID
        proof</label>
      <select class="form-select form-select-lg h-48" [(ngModel)]="selectedIDProof">
        <option disabled selected value="null">Select proof type</option>
        <option *ngFor="let item of idProofList" value="{{item.value}}">{{ item.name }}</option>
      </select>
    </div>
    <div class="upload-document">
      <label class="form-label mend">Document No.</label>
      <input type="text" class="form-control h-48" placeholder="Ex:ABCTY1234D" name="pan" id="pan" [ngClass]="(isAddKYCDone && isIdKYCDone ) || isIdKYCDone ? 'disabled' : ''"
        minlength="10" maxlength="10" [(ngModel)]="selectedIdDocNo"
        oninput="this.value = this.value.toUpperCase()" />

    </div>
  </div>

</div>
<div class="row p-3">
  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 offset-md-6 text-end mb-3">
    <button type="button" [ngClass]="(isAddKYCDone && isIdKYCDone ) || isIdKYCDone ? 'disabled' : ''"
      class="btn w-50 btn-primary btn-lg btn-grad-primary btn-compare btn-disabled"
      (click)="submitKYC()" data-toggle="tooltip" data-placement="top"
      title="Click here for Save">Submit </button>
  </div>
</div>


</div>
